import { render, staticRenderFns } from "./SpeechSettingsTab.vue?vue&type=template&id=57018534&scoped=true"
import script from "./SpeechSettingsTab.vue?vue&type=script&lang=js"
export * from "./SpeechSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./SpeechSettingsTab.vue?vue&type=style&index=0&id=57018534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57018534",
  null
  
)

export default component.exports